import React from 'react';

import { Link } from '@confluence/route-manager/entry-points/Link.ts';
import { cleanExcerpt, enrichExcerpt } from '@confluence/search-utils/entry-points/excerpt.ts';

import type { AdvancedSearchResultType } from '../../AdvancedSearch-types.ts';
import { CONTEXT_PATH } from '../../AdvancedSearch-constants.ts';
import { Icon } from '../Icon.tsx';

import {
	ResultContainer,
	ResultMainContainer,
	ResultIconContainer,
	ResultTitleMetadataContainer,
	ResultTitle,
} from './styled.tsx';

interface SpaceResultProps {
	searchResult: AdvancedSearchResultType;
	onClickResult: () => void;
	onContextClickResult: () => void;
}

export const SpaceResult = ({
	searchResult,
	onClickResult,
	onContextClickResult,
}: SpaceResultProps) => {
	const {
		title: spaceName,
		entityType,
		space: {
			webui: spaceUrl,
			icon: { path: iconPath },
		},
	} = searchResult;

	return (
		<ResultContainer>
			<ResultMainContainer>
				<ResultIconContainer>
					<Icon
						contentType={entityType}
						iconPath={iconPath}
						resultTitle={cleanExcerpt(spaceName)}
					/>
				</ResultIconContainer>
				<ResultTitleMetadataContainer>
					<ResultTitle>
						<Link
							href={`${CONTEXT_PATH}${spaceUrl}`}
							onClick={onClickResult}
							onContextMenu={onContextClickResult}
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="searchResultLink"
						>
							{enrichExcerpt(spaceName)}
						</Link>
					</ResultTitle>
				</ResultTitleMetadataContainer>
			</ResultMainContainer>
		</ResultContainer>
	);
};
